var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"land-neopark-district-section"},[_c('disMain'),_c('div',{staticClass:"content-bg"},[_c('disLocation'),_c('disParks'),_c('disAround')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }